function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.8 2H3.4C2.07452 2 1 3.07452 1 4.4V6.8H2.6V4.4C2.6 3.95817 2.95817 3.6 3.4 3.6H5.8V2Z",
  fill: "#FCFCFC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1 15.6V13.2H2.6V15.6C2.6 16.0418 2.95817 16.4 3.4 16.4H5.8V18H3.4C2.07452 18 1 16.9255 1 15.6Z",
  fill: "#FCFCFC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4 13.2V15.6C15.4 16.0418 15.0418 16.4 14.6 16.4H12.2V18H14.6C15.9255 18 17 16.9255 17 15.6V13.2H15.4Z",
  fill: "#FCFCFC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17 4.4V6.8H15.4V4.4C15.4 3.95817 15.0418 3.6 14.6 3.6H12.2V2H14.6C15.9255 2 17 3.07452 17 4.4Z",
  fill: "#FCFCFC"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9 12.4C10.3255 12.4 11.4 11.3255 11.4 10C11.4 8.67452 10.3255 7.6 9 7.6C7.67452 7.6 6.6 8.67452 6.6 10C6.6 11.3255 7.67452 12.4 9 12.4Z",
  fill: "#FCFCFC"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 18.9412L0.0588467 1.99999L1.11951 0.939331L18.0607 17.8805L17 18.9412Z",
  fill: "white"
});

function SvgIconStopLive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStopLive);
export default __webpack_public_path__ + "static/media/icon-stop-live.8bb16d55.svg";
export { ForwardRef as ReactComponent };